import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
import { smoothScrollToId } from '../../common/utils/scrollTo';

import {
  FooterSection,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Chat,
  Language,
} from "./styles";

const Footer = ({ t }: { t: TFunction }) => {
  const scrollTo = (id: string) => {
    smoothScrollToId(id);
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Language>{t("Address")}</Language>
              <Para>AAA Home Health Care, LLC</Para>
              <Para>P.O. Box 5388</Para>
              <Para>Vallejo, California</Para>
            </Col>
            <Col lg={10} md={10} sm={12} xs={12}>
              <Language>{t("Contact")}</Language>
              <Para>
                {t(`Have any questions? Submit a contact form here to schedule a free consultation.`)}
              </Para>
              <Chat onClick={() => scrollTo("contact")}>
                {t(`Let's Chat`)}
              </Chat>
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container>
          <Row
            justify="space-between"
            align="middle"
          >
            <NavLink to="/">
              <LogoContainer>
                <SvgIcon
                  src="logo.svg"
                  aria-label="homepage"
                  width="101px"
                  height="64px"
                />
              </LogoContainer>
            </NavLink>
          </Row>
          <Row justify="center" style={{ marginTop: "0.5rem", marginBottom: "0.25rem" }}>
            <Col>
              <Para style={{ textAlign: "center", fontSize: "0.95rem", color: "rgb(75, 58, 88)", whiteSpace: "nowrap" }}>
                Licensed with the State of California Department of Social Services HCO Number 484700027
              </Para>
            </Col>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
